/* import __COLOCATED_TEMPLATE__ from './status.hbs.js'; */
import { assert } from '@ember/debug';
import Component from '@glimmer/component';
const ALLOWED_LEVELS = ['error', 'inactive', 'in-progress', 'validated', 'waiting'];
export default class BadgeStatusComponent extends Component {
  get level() {
    let level = this.args.level ?? 'waiting';
    assert('<Badge::Status /> can only have those levels: error, inactive, in-progress, validated, waiting', ALLOWED_LEVELS.includes(level));
    return level;
  }
}